import { c as _c } from "react/compiler-runtime";
import { Link } from "@opensea/next-ui-kit";
import { Tooltip } from "@opensea/ui-kit";
import { Discord as DiscordIcon, Instagram as InstagramIcon, Language, Telegram as TelegramIcon, Twitter as TwitterIcon } from "@opensea/ui-kit/icons";
import { UnreachableCaseError } from "@opensea/utils";
import { useTranslations } from "next-intl";

// Regex for removing leading @ symbols
const LEADING_ATS_REGEX = /^@+/;
const removeLeadingAts = str => str.replace(LEADING_ATS_REGEX, "");
export const getSocialAccountUrl = (social, username) => {
  switch (social) {
    case "instagram":
      return `https://instagram.com/${removeLeadingAts(username)}`;
    case "twitter":
      return `https://x.com/${username}`;
    case "telegram":
      return `https://t.me/${username}`;
    default:
      throw new UnreachableCaseError(social);
  }
};
function Instagram(t0) {
  const $ = _c(15);
  let rest;
  let username;
  if ($[0] !== t0) {
    ({
      username,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = username;
  } else {
    rest = $[1];
    username = $[2];
  }
  const t = useTranslations("SocialLinks");
  let t1;
  if ($[3] !== t) {
    t1 = t("instagram");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== username) {
    t2 = getSocialAccountUrl("instagram", username);
    $[5] = username;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== rest) {
    t3 = <InstagramIcon fill="interactive-primary-styles" size={20} {...rest} />;
    $[7] = rest;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Link href={t2} variant="unstyled">{t3}</Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t4) {
    t5 = <Tooltip content={t1}>{t4}</Tooltip>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function Twitter(t0) {
  const $ = _c(10);
  let rest;
  let username;
  if ($[0] !== t0) {
    ({
      username,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = username;
  } else {
    rest = $[1];
    username = $[2];
  }
  let t1;
  if ($[3] !== username) {
    t1 = getSocialAccountUrl("twitter", username);
    $[3] = username;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest) {
    t2 = <TwitterIcon fill="interactive-primary-styles" size={20} {...rest} />;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <Link href={t1} variant="unstyled">{t2}</Link>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function Discord(t0) {
  const $ = _c(13);
  let href;
  let rest;
  if ($[0] !== t0) {
    ({
      href,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = rest;
  } else {
    href = $[1];
    rest = $[2];
  }
  const t = useTranslations("SocialLinks");
  let t1;
  if ($[3] !== t) {
    t1 = t("discord");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest) {
    t2 = <DiscordIcon fill="interactive-primary-styles" size={20} {...rest} />;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== href || $[8] !== t2) {
    t3 = <Link href={href} variant="unstyled">{t2}</Link>;
    $[7] = href;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <Tooltip content={t1}>{t3}</Tooltip>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function Website(t0) {
  const $ = _c(13);
  let href;
  let rest;
  if ($[0] !== t0) {
    ({
      href,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = rest;
  } else {
    href = $[1];
    rest = $[2];
  }
  const t = useTranslations("SocialLinks");
  let t1;
  if ($[3] !== t) {
    t1 = t("website");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest) {
    t2 = <Language fill="interactive-primary-styles" size={20} {...rest} />;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== href || $[8] !== t2) {
    t3 = <Link href={href} variant="unstyled">{t2}</Link>;
    $[7] = href;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <Tooltip content={t1}>{t3}</Tooltip>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function Telegram(t0) {
  const $ = _c(15);
  let rest;
  let username;
  if ($[0] !== t0) {
    ({
      username,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = username;
  } else {
    rest = $[1];
    username = $[2];
  }
  const t = useTranslations("SocialLinks");
  let t1;
  if ($[3] !== t) {
    t1 = t("telegram");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== username) {
    t2 = getSocialAccountUrl("telegram", username);
    $[5] = username;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== rest) {
    t3 = <TelegramIcon fill="interactive-primary-styles" size={20} {...rest} />;
    $[7] = rest;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Link href={t2} variant="unstyled">{t3}</Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t4) {
    t5 = <Tooltip content={t1}>{t4}</Tooltip>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
export const SocialLinks = {
  Instagram,
  Twitter,
  Discord,
  Website,
  Telegram
};